'use strict';

import { BufferGeometry, CatmullRomCurve3, Group, LinearSRGBColorSpace, Vector3, Color } from 'three';
import { LineGeometry } from 'three/examples/jsm/lines/LineGeometry';
import { LineMaterial } from 'three/examples/jsm/lines/LineMaterial';
import { Line2 } from 'three/examples/jsm/lines/Line2';
import { latLngAltToVector3 } from '../components/publicLayers/Layer';
import { Terrain } from '../components/Terrain/Terrain';
import { threeJsVariables } from '../../settings';

export class Route extends Terrain{
    constructor () {
        super();
        const { position,rotation } = config.features.publicLayers.routs || { position: { x:0,y:0,z:0 },rotation: { x:0,y:0,z:0 } };
        this.routes = {};
        this.position = position;
        this.rotation = rotation;
        this.drawGroup = new Group();
        this.drawGroup.name = 'Route';
        this.drawGroup.position.set(position.x,position.y,position.z);
        this.drawGroup.rotation.set(rotation.x,rotation.y,rotation.z);
    }

    drawRoute(route,id){
        this.removeRoute();

        if (!this.routes[id]) {

            const routePath = route.routes[0].overview_path;
            const highwayPreset = config.features.publicLayers.layers.find(layer => layer.type === 'highway');
            const colors = {
                primary: highwayPreset?.colors.primary || '#ffd000',
                secondary: highwayPreset?.colors.secondary || '#ffffff',
            };
            this.routes[id] = {
                active: true,
                path: []
            };
            const points = [];
            const center = {lat: Number(config.localization.latitude), lng: Number(config.localization.longitude)};
            const vectorToIntersect = new Vector3();
            const axis = new Vector3(0,1,0).normalize();

            routePath.forEach(coords => {
                const point = {lat: coords.lat(), lng: coords.lng()};
                const vector = latLngAltToVector3(point,center);
                vectorToIntersect.copy(vector);
                vectorToIntersect.applyAxisAngle(axis,this.rotation.y);
                vectorToIntersect.add(this.drawGroup.position);
                !config.features.publicLayers.routs?.preventRaycasting
                  ? vector.y = this.intersectHeightFromVector3(vectorToIntersect)
                  : vector.y = 0;
                points.push(vector);
            });

            // const geometry = new BufferGeometry().setFromPoints(points);
            // const curve = new CatmullRomCurve3(points);
            // curve.curveType = 'centripetal';
            // curve.tension = 0.5;
            // const curvedPoint = curve.getPoints(10);
            const geometry = new BufferGeometry().setFromPoints(points);
            const lineGeometry = new LineGeometry().setPositions(geometry.getAttribute('position').array);
            const lineMaterial = new LineMaterial({
                color: new Color().setStyle(colors.primary,LinearSRGBColorSpace),
                linewidth: 5,
                dashed: false,
                opacity: 0.9,
                alphaToCoverage: true
            });

            lineMaterial.resolution.set( window.innerWidth / 4, window.innerHeight / 4 );

            const dashLineMaterial = new LineMaterial({
                color: new Color().setStyle(colors.secondary,LinearSRGBColorSpace),
                linewidth: 5,
                dashed: true,
                dashOffset: 1,
                opacity: 0.6,
                gapSize: 20,
                dashSize: 10,
                alphaToCoverage: true
            });

            dashLineMaterial.resolution.set( window.innerWidth / 4, window.innerHeight / 4 );

            const dashLine = new Line2(lineGeometry,dashLineMaterial);
            dashLine.name = 'route_dash';
            dashLine.computeLineDistances();
            dashLine.scale.set(1,1,1);

            dashLineMaterial.tick = () => {
                dashLineMaterial.dashOffset -= 1;
            };

            const line = new Line2(lineGeometry,lineMaterial);
            line.name = 'route_line';
            line.computeLineDistances();
            line.scale.set(1,1,1);
            this.routes[id].path.push(line,dashLine);
        }

        this.routes[id].active = true;
        this.drawGroup.add(...this.routes[id].path);
        threeJsVariables.scene.add(this.drawGroup);

        return this.routes[id].path.find(el => el.name === 'route_dash').material;
    }

    removeRoute() {
       const activeRoute = Object.values(this.routes)?.find(route => route.active);
       if (activeRoute) {
           activeRoute.active = false;
           activeRoute.path.forEach(el => {
               el.removeFromParent();
               el.geometry.dispose();
               el.material.dispose();
           });
       }
       this.drawGroup.removeFromParent();
    }

}
